import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup, Transition } from 'react-transition-group';
import anime from 'animejs';
import PropTypes from 'prop-types';

/* eslint-disable */
import Modernizr from '../modernizr';
/* eslint-enable */
import Nav from './Nav';
import Heyo from './Heyo';
import Play from './Play';
import Bits from './Bits';
import Post from './Post';
import FourZeroFour from './FourZeroFour';


class App extends Component {
  constructor() {
    super();
    this.loadData = this.loadData.bind(this); // bind loadData to App so can use it
    // this.currentPage = '';
    // this.prevPage = '';
  }

  // set initial state
  state = {
    projects: [],
    blogPosts: [],
  };

  // Update parent state from child component
  // https://ourcodeworld.com/articles/read/409/how-to-update-parent-state-from-child-component-in-react
  async loadData(dataLocation, objToUpdate) {
    if (this.state[objToUpdate].length > 1) { // exit if already fetched json
      return new Promise((resolve) => {
        resolve('data already loaded');
      });
    }

    try {
      const res = await fetch(dataLocation);
      const data = await res.json();
      // this.setState({ projects }); // put project data in state on App
      this.setState({ [objToUpdate]: data });
      return new Promise((resolve) => {
        resolve('data loaded');
      });
      // console.log('success!');
    } catch (e) {
      console.error(e);
      return new Promise((resolve, reject) => {
        reject(new Error('data NOT loaded'));
      });
      // console.log('error!');
    }
  }


  render() {
    let indexPageClass = '';
    let thisPageClass = '';
    // this.prevPage = this.currentPage;
    // this.currentPage = this.props.location.pathname;
    if (this.props.location.pathname === '/' || this.props.location.pathname === '/heyo/' || this.props.location.pathname === '/bits/') {
      indexPageClass = 'index-page';
    }
    if (this.props.location.pathname === '/') {
      thisPageClass = 'play';
    } else if (this.props.location.pathname === '/heyo/') {
      thisPageClass = 'heyo';
    } else if (this.props.location.pathname === '/bits/') {
      thisPageClass = 'bits';
    } else if (this.props.location.pathname.startsWith('/play/')) {
      thisPageClass = 'project';
    } else if (this.props.location.pathname.startsWith('/bits/')) {
      thisPageClass = 'blogpost';
    } else {
      thisPageClass = 'other';
    }

    let lightNavClass = '';
    if (this.props.location.pathname === '/play/williams-dame/') {
      lightNavClass = 'light-nav';
    }

    return (
      <div className={`${thisPageClass} ${indexPageClass} ${lightNavClass}`}>

        <Nav />

        <Route render={({ location }) =>(

          // https://hackernoon.com/animated-page-transitions-with-react-router-4-reacttransitiongroup-and-animated-1ca17bd97a1a
          // http://animate.mhaagens.me/
          // https://codesandbox.io/s/mQy3mMznn
          // https://github.com/aholachek/react-animation-comparison/blob/master/src/react-transition-group-example-anime.js
          // http://alex.holachek.com/react-animation-comparison/?selectedKind=Animation%20Examples&selectedStory=Using%20react%20transition%20group%20%2B%20animejs&full=0&down=1&left=1&panelRight=0&downPanel=tuchk4%2Freadme%2Fpanel
          <TransitionGroup component="main" className="main-container">
            <Transition
              key={this.props.location.pathname}
              timeout={500}
              mountOnEnter
              unmountOnExit
              appear
              onEnter={(node) => {
                const el = node;
                //window.scrollTo(0, 0);
                document.documentElement.classList.add('transitioning');
                el.style.position = 'fixed';
                el.style.zIndex = '1';
                // el.style.width = '100%';
                // el.style.position = 'absolute';
                // el.style.top = '0';
                // el.style.left = '0';
                anime({
                  targets: el,
                  duration: 500,
                  opacity: [0, 1],
                  // translateY: ['-10px', '0'],
                  easing: 'linear',
                });
              }} // on enter end

              onEntered={(node) => {
                const el = node;
                // if (
                //   (this.currentPage === '/' || this.currentPage === '/bits' || this.currentPage === '/heyo') &&
                //   (this.prevPage === '/' || this.prevPage === '/bits' || this.prevPage === '/heyo')
                // ) {
                //
                // } else {}
                window.scrollTo(0, 0);
                el.style.position = 'relative';
                document.documentElement.classList.remove('transitioning');
              }}

              onExit={(node) => {
                const el = node;
                el.style.position = 'absolute';
                el.style.zIndex = '0';
                // anime({
                //   targets: el,
                //   duration: 500,
                //   opacity: [1, 0],
                //   // translateY: ['0', '-10px'],
                //   easing: 'linear',
                // });
              }} // on exit end
            >

              <Switch key={location.key} location={location}>
                <Route
                  exact
                  path="/"
                  render={() => (
                    <Play posts={this.state.projects} loadData={this.loadData} />
                  )}
                />
                <Route
                  exact
                  strict
                  path="/play/:slug/"
                  render={props => (
                    <Post postType="Project" posts={this.state.projects} loadData={this.loadData} {...props} />
                  )}
                />
                {/* pass props to component using router render https://github.com/ReactTraining/react-router/issues/4627 */}
                <Route
                  strict
                  path="/heyo/"
                  render={() => (
                    <Heyo />
                  )}
                />
                <Route
                  exact
                  strict
                  path="/bits/"
                  render={() => (
                    <Bits posts={this.state.blogPosts} loadData={this.loadData} />
                  )}
                />
                <Route
                  exact
                  strict
                  path="/bits/:slug/"
                  render={props => (
                    <Post postType="BlogPost" posts={this.state.blogPosts} loadData={this.loadData} {...props} />
                  )}
                />
                {/* <Redirect to="/" /> */}
                <Route path="*" component={FourZeroFour} />
              </Switch>
            </Transition>
          </TransitionGroup>
          )}
        />

      </div>
    );
  }
}

export default App;

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/App.js